export const CardStates = Object.freeze({
    IDLE:   1,
    FLIPPED:2,
    MATCHED:3
});

export const GameStates = Object.freeze({
    IDLE:   1,
    PLAYING:2,
    COMPLETED:3
});

